{
    "TITLE" : "Удаленное приложение",
        "SHARED": {
            "INTERNET_OFFLINE": "Ваше интернет-соединение, кажется, в автономном режиме.",
            "LANGUAGE": "язык",
            "NO_FEATURE": "Ваша лицензия не содержит эту функцию. Пожалуйста, свяжитесь с вашим администратором.",
            "FEATURE_UNAVAILABLE": "Ваша лицензия не содержит эту функцию. Пожалуйста.",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "У вас нет разрешения на использование этой функции. Пожалуйста, спросите разрешения у Хозяина."
        },
        "UPDATE_MODAL": {
            "TITLE": "Доступно обновление",
            "MESSAGE": "Доступна новая версия. Эта страница будет перезагружена после обновления.",
            "UPDATE": "Перезагрузить",
            "UPDATE_FAILED": "Не удалось обновить"
        },
        "LOGIN" : {
        "SSO-BUTTON": "Войти через SSO",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "Вход в удаленное приложение",
            "ACCOUNT_PLACEHOLDER" : "Имя пользователя",
            "ACCOUNT_REQUIRED" : "Имя учетной записи обязательно.",
            "ACCOUNT_SHORT" : "Имя учетной записи должно быть не менее 2 символов.",
            "USERNAME_PLACEHOLDER" : "имя пользователя",
            "USERNAME_REQUIRED" : "Имя пользователя обязательно.",
            "USERNAME_SHORT" : "Имя пользователя должно содержать не менее 2 символов.",
            "PASSWORD_PLACEHOLDER" : "пароль",
            "PASSWORD_REQUIRED" : "Необходим пароль.",
            "PASSWORD_SHORT" : "Пароль должен содержать не менее 6 символов.",
            "REMEMBER_ACCOUNT_NAME": "Запомнить имя аккаунта",
            "VERIFICATION_CODE": "Код подтверждения",
            "TWO_FACTOR_EMAIL_SENDED": "Мы отправили вам письмо с кодом подтверждения.",
            "VERIFY_BUTTON": "ПРОВЕРКИ",
            "LOGIN_BUTTON" : "логин",
            "BACK_BUTTON" : "Вернуться",
            "BEFORE_TERMS": "Нажимая кнопку «Войти», вы соглашаетесь с нашими ",
            "TERMS": "условия обслуживания",
            "CONJUNCTION": " а также ",
            "PRIVACY": "политика конфиденциальности",
            "AFTER_PRIVACY": ".",
            "GUEST_DELETED": "Вы вышли из системы.",
            "USER_DELETED": "Ваш аккаунт был удален. Пожалуйста, свяжитесь с вашим администратором.",
            "USER_DISABLED": "Ваш аккаунт был отключен. Пожалуйста, свяжитесь с вашим администратором.",
            "LOGGED_IN_ANOTHER_SESSION": "Вы вошли в другой сеанс.",
            "LOGGED_OUT_UNKNOWN": "Что-то пошло не так.",
            "NO_INTERNET_ERROR": "Без интернета. Пожалуйста, проверьте подключение к интернету.",
            "USERNAME_PASSWORD_ERROR" : "Неверное имя учетной записи, имя пользователя или пароль.",
            "ACCOUNT_DISABLED": "Срок действия вашего аккаунта истек. Пожалуйста, свяжитесь с {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "Неверный двухэтапный код подтверждения.",
            "UNKNOWN_ERROR" : "Произошла ошибка при входе.",
            "SIMULTANE_LOGIN_ERROR": "Вы вошли в другой сеанс.",
            "USE_CHINA_SERVERS": "Я вхожу из китая",
            "CHINA_SERVERS_CAUTION": "Эта опция может вызвать задержку за пределами материкового Китая.",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "Множественный вход",
                "MESSAGE": "Ваш пользователь уже вошел в систему на другом устройстве. Если вы продолжите, другой пользователь выйдет из системы.",
                "CANCEL": "Отмена",
                "PROCEED": "проследовать"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "У вас есть {{ days }} дня в вашей лицензии {{ appName }} Remote.",
            "DEMO_LEFT": "У вас есть {{ days }} дня на пробную версию {{ appName }} Remote.",
            "LEFT_BAR": {
                "LOBBY": "Лобби",
                "ROOMS": "Номера",
                "MEETINGS": "Встречи",
                "FEEDBACK": "Обратная связь",
                "CONTACTS": "Пользователи",
                "SESSIONS": "Сессии",
                "TICKETS": "Tickets",
                "PRECALL_TEST": "Тест Precall",
                "WHATS_NEW": "Что нового",
                "PROFILE": "Профиль",
                "HELP_CENTER": "Центр помощи",
                "LOGOUT": "Выйти"
            },
            "CALL_MESSAGE": {
                "TITLE":"Входящий звонок от <strong>{{ caller_name }}</strong>",
                "DENY": "Отрицать",
                "ACCEPT": "принимать"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "Получить экспорт сессии",
                "MESSAGE1": "Пожалуйста, введите свой адрес электронной почты, чтобы получить ссылку на загрузку экспорта сеанса после окончания сеанса.",
                "MESSAGE2": "Экспорт сеанса будет включать все <strong>сообщения чата</strong>, <strong>снимки</strong>, <strong>записи видеозвонков</strong> и <strong>файлы</strong>, к которым был предоставлен общий доступ в сеансе.",
                "EXPORT_NAME_NOT_LOCKED": "Вы можете переименовать файл экспорта, введя вместо него собственное имя файла.",
                "EXPORT_NAME_LOCKED": "Вы сможете переименовать файл экспорта, как только другой пользователь завершит экспорт.",
                "EXPORT_NAME_RENAMED": "Файл экспорта переименован этим пользователем:",
                "EXPORT_NAME_PLACEHOLDER": "Имя экспорта",
                "NOTE": "Примечание. Вы можете обновить свой адрес электронной почты в меню профиля.",
                "NOTE2": "Примечание. Вы можете обновить свой адрес электронной почты через администратора.",
                "OPEN_PROFILE": "Открыть профиль",
                "EMAIL": "Эл. адрес",
                "EMAIL_REQUIRED": "Требуется электронная почта.",
                "EMAIL_INVALID": "Неверный формат электронной почты.",
                "CLOSE": "близко",
                "SEND": "Отправить",
                "EXPORT_SUCCEEDED": "Экспорт сеанса будет отправлен после окончания сеанса.",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "Экспорт сеанса отправлен.",
                "EXPORT_FAILED": "Произошла ошибка."
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Управление публичным доступом",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Вы можете прекратить совместное использование этого рабочего процесса, удалив публичный доступ.",
                "GENEATE-ACCESS-TEXT": "Вы можете создать публичную ссылку и QR-код для создания легкого доступа к этому рабочему процессу.",
                "ENABLE-PASSWORD": "Включить пароль",
                "GENERATE-ACCESS": "Создать",
                "LINK": "Ссылка",
                "COPY": "Копировать",
                "QR-CODE": "QR-код",
                "DOWNLOAD": "Скачать",
                "SECURITY": "Безопасность",
                "PASSWORD-PROTECTED": "Защищено паролем",
                "PUBLIC": "Публичный",
                "DELETE-ACCESS": "Удалить публичный доступ",
                "EASY-ACCESS-TITLE": "{{ shortName }} Легкий доступ к рабочему процессу",
                "OPEN-WORKFLOW-NAME": "Вы собираетесь открыть",
                "GUEST-EMAIL": "Email гостя",
                "REQUIRED": "Это поле обязательно",
                "GUEST-PASSWORD": "Пароль для гостей",
                "OPEN": "ОТКРЫТЬ",
                "OPEN-APP": "Мы рекомендуем открыть этот рабочий процесс в нашем приложении для лучшего опыта.",
                "COPY-LINK-TEXT": "Скопируйте ссылку в буфер обмена, чтобы открыть этот рабочий процесс при запуске приложения.",
                "DOWNLOAD-APP": "СКАЧАТЬ ПРИЛОЖЕНИЕ",
                "DOWNLOAD-SMARTGLASSES-APP": "СКАЧАТЬ ПРИЛОЖЕНИЕ ДЛЯ УМНЫХ ОЧКОВ",
                "OR": "ИЛИ",
                "CONTINUE-WITH-BROWSER": "Продолжить в браузере",
                "PASSWORD-PROTECTED-TEXT": "Когда пароль включен, пользователи, имеющие публичную ссылку или QR-код, могут получить доступ к этому рабочему процессу только после ввода пароля.",
                "CREATE-PASSWORD": "Создать пароль",
                "ENTER-EMAIL": "Введите ваш email",
                "ENTER-WORKFLOW-PASSWORD": "Введите пароль рабочего процесса",
                "DELETE-QR-TEXT": "Чтобы изменить тип безопасности Легкого доступа, вы должны удалить Легкий доступ и создать его снова.",
                "LOADING-WORKFLOW": "Загрузка рабочего процесса...",
                "UNABLE-TO-LOAD": "Не удалось загрузить рабочий процесс",
                "RETRY": "Повторить",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Токен отсутствует или недействителен",
                    "ID-MISSING": "Отсутствует ID рабочего процесса или базовый URL",
                    "WORKFLOW-NOT-PUBLISHED": "Рабочий процесс не опубликован",
                    "PUBLIC-ACCESS": "Публичный доступ уже существует",
                    "NO-PUBLIC-ACCESS": "Нет публичного доступа"
                },
                "QR-INFORMATION": "Информация QR"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Видео потоки",
                "CREATE-VIDEO-FLOW": "Создать видео поток",
                "CREATED-BY-AI": "Создано ИИ",
                "VERSION": "Версия",
                "NO-VIDEO-FLOWS-FOUND": "Видео потоки не найдены",
                "CLEAR-ALL": "Очистить все",
                "CONFIRM-VIDEO": "Подтвердить видео",
                "CONFIRM-VIDEO-TITLE": "Подтвердить преобразование видео",
                "CONFIRM-VIDEO-MESSAGE": "Вы уверены, что хотите преобразовать этот видеопоток в рабочий процесс? После подтверждения вы не сможете редактировать видео.",
                "CONFIRM-VIDEO-BUTTON": "Подтвердить и преобразовать",
                "MAKE-WORKFLOW-SUCCESSFUL": "Успешно преобразовано в рабочий процесс",
                "MAKE-WORKFLOW-ERROR": "Не удалось преобразовать в рабочий процесс",
                "UPLOAD-VIDEO-DESCRIPTION": "Загрузите свое видео, чтобы автоматически создать пошаговое руководство по рабочему процессу.",
                "VIDEO-DURATION-LIMIT": "Длительность видео не может превышать 30 минут.",
                "VIDEO-UPLOADED-SUCCESS": "Видео успешно загружено!",
                "SELECT-VIDEO": "Выбрать видео",
                "CHANGE-VIDEO": "Изменить видео",
                "CREATE-BUTTON": "Создать",
                "AI-PROCESSING": "Идет обработка ИИ",
                "SPLITTING-VIDEO": "Разделение видео на сегменты",
                "TRANSCRIBING-VIDEO": "Транскрибирование содержимого видео",
                "PROCESS-WARNING": "Этот процесс может занять до 10 минут. Пожалуйста, не закрывайте это окно."
            },
            "NAVBAR" : {
                "PRECALL_TEST": "Тест Precall.",
                "PRECALL_END_SESSION": "Пожалуйста, закончите сессию перед тестом Precall.",
                "LOGOUT" : "Выйти",
                "LANGUAGE" : "язык",
                "LOGOUT_MODAL_TITLE": "Выйти?",
                "LOGOUT_MODAL_MESSAGE": "Это выйдет из вас.",
                "CAUTION": "Внимание: это приведет к выходу из системы без завершения сеанса. Всплывающие окна и другая информация после сеанса могут быть потеряны (например, экспорт сеанса)!",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "Вы выйдете из сеанса и выйдете из системы.",
                "LOGOUT_MODAL_NO": "отменить",
                "LOGOUT_MODAL_YES": "Выйти",
                "LOGOUT_FAILED": "При выходе из системы произошла ошибка.",
                "HELP_CENTER": "Центр помощи",
                "PROFILE_TITLE": "Профиль",
                "PROFILE_NAME": "название",
                "PROFILE_EMAIL": "Эл. адрес",
                "PROFILE_PASSWORD": "пароль",
                "PROFILE_CHANGE_LINK": "Изменять",
                "PROFILE_ADD_LINK": "Добавлять",
                "PROFILE_CLOSE": "близко",
                "CHANGE_PASS_TITLE": "Изменить пароль",
                "CHANGE_PASS_OLD_PASS": "Прежний пароль",
                "CHANGE_PASS_NEW_PASS": "новый пароль",
                "CHANGE_PASS_RPT_PASS": "Подтверждать пароль",
                "CHANGE_PASS_REQUIRED": "Необходим пароль.",
                "CHANGE_PASS_NOT_MATCH": "Пароли не совпадают.",
                "CHANGE_PASS_CLOSE_BTN": "близко",
                "CHANGE_PASS_CHANGE_BTN": "Изменить пароль",
                "CHANGE_PASS_SUCCESS": "Ваш пароль изменился.",
                "CHANGE_PASS_WRONG": "Ваш пароль неверный.",
                "CHANGE_PASS_FAILED": "Смена пароля не удалась.",
                "CHANGE_EMAIL_TITLE": "Изменить e-mail",
                "CHANGE_EMAIL_NEW_EMAIL": "Новый E-mail",
                "CHANGE_EMAIL_RPT_EMAIL": "Подтверждать E-mail",
                "CHANGE_EMAIL_REQUIRED": "Электронная почта обязательна.",
                "CHANGE_EMAIL_NOT_VALID": "E-mail не является допустимым.",
                "CHANGE_EMAIL_NOT_MATCH": "Адреса электронной почты не совпадают.",
                "CHANGE_EMAIL_CLOSE_BTN": "близко",
                "CHANGE_EMAIL_CHANGE_BTN": "Изменить e-mail",
                "CHANGE_EMAIL_SUCCESS": "Ваш адрес электронной почты изменился.",
                "CHANGE_EMAIL_FAILED": "Не удалось изменить адрес электронной почты.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "Благодарим за отправку формы. Наша команда свяжется с вами в ближайшее время.",
                "CLOSE": "Закрывать",
                "CREATE_NEW_PASS": "Требования к паролю",
                "UPPERCASE": "Верхний регистр",
                "LOWERCASE": "Строчные буквы",
                "NUMBER": "Число",
                "SPECIAL": "Специальный",
                "AT_LEAST_PASSWORD_LENGTH": "Не менее {{passwordlength}} символов",
                "OLD_PASSWORD": "Прежний пароль",
                "NOT_WHITESPACE": "Ваш пароль не должен содержать пробелов",
                "DO_NOT_CREATE_SIMPLE": "Не создавайте слабые пароли вроде '123456'.",
                "STATUS": {
                    "AVAILABLE": "Доступный",
                    "BUSY": "Занятый",
                    "APPEAR_OFFLINE": "Появляться оффлайн"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "Текущие звонки",
                    "ROOMS_TITLE": "Ваши комнаты",
                    "UPCOMING_MEETINGS_TITLE" : "Предстоящие встречи",
                    "PREVIOUS_MEETINGS_TITLE" : "Предыдущие встречи",
                    "SCHEDULE_MEETING": "Расписание встречи",
                    "INSTANT_GUEST_ACCESS": "Мгновенный гостевой доступ",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "У вас нет разрешения на звонки. Пожалуйста, обратитесь к администратору.",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "У вас нет разрешения на создание ссылки для гостевого доступа. Пожалуйста, обратитесь к администратору.",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "У вас нет разрешения на звонки и создание ссылки для гостевого доступа. Пожалуйста, обратитесь к администратору.",
                    "LINK_UNAVAILABLE": "Ссылка недоступна",
                    "JOIN" : "логин",
                    "CANCEL": "ОТМЕНИТЬ",
                    "REMOVE": "УДАЛИТЬ",
                    "NO_ROOM": "У тебя нет комнаты.",
                    "NO_MEETING": "У вас нет встречи.",
                    "NO_PREV_MEETING": "У вас нет встречи.",
                    "NO_OTHER_USERS": "Других пользователей нет.",
                    "SHOW_MORE": "показать ещё {{count}}",
                    "SHOW_LESS": "показывай меньше"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "Расписание встречи",
                    "MEETING_TITLE": "Заголовок*",
                    "MEETING_TITLE_REQUIRED": "Требуется название.",
                    "START_DATE": "Начинать",
                    "END_DATE": "Конец",
                    "CLOSE": "Закрывать",
                    "SCHEDULE_SEND": "Расписание и отправить",
                    "SCHEDULE": "расписание",
                    "CANNOT_SCHEDULE": "Произошла ошибка при планировании встречи.",
                    "CANNOT_CANCEL_MEETING": "Произошла ошибка при отмене встречи.",
                    "ENTER_USERS": "Введите пользователей",
                    "SEND_INVITATIONS": "Отправить приглашения",
                    "INVITATION_EMAIL_LANG": "Язык электронного приглашения",
                    "SHARE_AFTER": "Ссылкой на встречу также можно поделиться после планирования."
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "Отменить встречу",
                    "REMOVE_TITLE": "Удалить встречу",
                    "CANCEL_MESSAGE": "Вы уверены, что хотите отменить встречу?",
                    "REMOVE_MESSAGE": "Вы уверены, что хотите удалить встречу?",
                    "CLOSE": "Закрывать",
                    "PROCEED": "Продолжить"
                },
                "CONTACTS": {
                    "TITLE": "Пользователи",
                    "NO_CONTACT": "Список пользователей пуст.",
                    "NO_PERMISSION": "У вас нет разрешения на просмотр списка пользователей и звонок.",
                    "SELECT_MULTI": "Выбрать несколько",
                    "CALL": "Вызов",
                    "ADMIN": "Админ",
                    "COADMIN": "Админ помощник",
                    "EXPERT": "Эксперт",
                    "SUBSCRIBER": "Подписчик",
                    "USER": "Пользователь",
                    "NAME": "название",
                    "USERNAME": "Имя пользователя",
                    "ROLE": "Роль",
                    "NO_EXPERT": "Выберите хотя бы одного эксперта, чтобы позвонить.",
                    "NAME_USERNAME": "Имя или имя пользователя",
                    "ALL_ROLES": "Все роли"
                },
                "SESSIONS": {
                    "TITLE": "Сессии",
                    "DATE": "Дата создания",
                    "DURATION": "Общая продолжительность",
                    "ROOM_NAME": "Комната",
                    "NO_SESSIONS": "Список сессий пуст.",
                    "PARTICIPANTS": "Участники",
                    "EXPORT": "Экспорт",
                    "STATUS": "Положение дел",
                    "ON_GOING": "Непрерывный",
                    "ENDED": "Завершено",
                    "FILES": "Файлы",
                    "CHAT": "Чат",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "Выбрать несколько",
                        "DOWNLOAD": "Скачать",
                        "DOWNLOAD_STARTED_SOON": "Загрузка начнется в ближайшее время.",
                        "DOWNLOAD_FAILED": "Ошибка загрузки.",
                        "NO_FILE_IS_ADDED": "В этом сеансе не было добавлено ни одного файла или совместной работы.",
                        "SUCCESS_MESSAGE": "Файлы были успешно загружены."
                    },
                    "ATTACHED_TICKET": "Прикрепленный билет",
                    "SESSION_DETAILS": "Сведения о сеансе",
                    "BACK": "Назад",
                    "GET_SESSION_EXPORT": "Получить экспорт сеанса",
                    "ATTACH_TO_TICKET": "Прикрепить к билету"
                },
                "TICKETS": {
                    "TITLE": "Билеты",
                    "NEW_TICKET": "Новый билет",
                    "ALL_ROOMS": "Все комнаты",
                    "ALL_STATUSES": "Все статусы",
                    "NO_TICKETS": "Список билетов пуст.",
                    "TICKET_TITLE": "Название",
                    "ROOM": "Комната",
                    "CREATED_BY": "Автор",
                    "CREATED_ON": "Дата создания",
                    "STATUS": "Статус",
                    "STATUS_OPEN": "открыто",
                    "STATUS_IN_PROGRESS": "в процессе",
                    "STATUS_CLOSED": "закрыто",
                    "CLOSE_PICK_TICKET": "ЗАКРЫТЬ",
                    "CREATE_NEW": "СОЗДАТЬ НОВОЕ",
                    "ATTACH": "ПРИКЛЮЧИТЬ",
                    "CREATE_TICKET": "Создать билет",
                    "TICKET_DETAILS": "Детали билета",
                    "EDIT": "РЕДАКТИРОВАТЬ",
                    "TICKET_TYPE": "Тип билета",
                    "ROOM2": "Комната:",
                    "CREATED_BY2": "Автор:",
                    "CREATED_ON2": "Дата создания:",
                    "ROOM3": "Комната",
                    "STATUS2": "Статус",
                    "PRIORITY": "Приоритет",
                    "ASSIGNEE": "Правопреемник",
                    "FOLLOW_UP": "Дата обращения",
                    "TICKET_TITLE2": "Название",
                    "TITLE_REQUIRED": "Требуется заголовок",
                    "DESCRIPTION": "Описание",
                    "DESCRIPTION_REQUIRED": "Требуется описание",
                    "RESOLUTION": "Резолюция",
                    "ATTACHED_SESSIONS": "ПРИКЛЮЧЕННЫЕ СЕССИИ",
                    "NO_ATTACHED_SESSIONS": "Список прикрепленных сеансов пуст",
                    "SESSION_COUNT": "Количество сеансов:",
                    "TOTAL_DURATION": "Общая продолжительность:",
                    "PARTICIPANTS2": "Участники:",
                    "COUNT_SESSIONS": "{{count}} сеансов",
                    "DATE": "Дата",
                    "ROOM_NAME": "Название комнаты",
                    "PARTICIPANTS": "Участники",
                    "DURATION": "Продолжительность",
                    "GUEST": "(Гость)",
                    "CANCEL": "ОТМЕНА",
                    "CLOSE": "ЗАКРЫТЬ",
                    "SAVE": "СОХРАНИТЬ",
                    "CREATE": "СОЗДАТЬ",
                    "CREATED_BETWEEN": "Создано между",
                    "ALL_CREATORS": "Все создатели",
                    "SEND_VIA_EMAIL": "ОТПРАВИТЬ ЧЕРЕЗ E-MAIL",
                    "DELETE_TICKET": "УДАЛИТЬ БИЛЕТ",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "Удалить билет?",
                        "MESSAGE": "Вы действительно хотите удалить билет <strong> {{title}} </strong>",
                        "CANCEL": "ОТМЕНА",
                        "DELETE": "УДАЛИТЬ"
                    },
                    "LOW": "Низкий",
                    "MEDIUM": "Середина",
                    "HIGH": "Высокая",
                    "CHOOSE_TICKET": "Выбрать билет",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "Билет уже прикреплен.",
                        "ERROR_OCCURED": "Произошла ошибка.",
                        "PERMISSION_DENIED": "Доступ запрещен.",
                        "MISSING_PARAMETERS": "Не хватает параметров",
                        "FILE_ALREADY_EXIST": "Файл уже существует"
                    },
                    "FILES": "Файлы",
                    "UPLOAD_FILE": "ЗАГРУЗИТЬ ФАЙЛ"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "Загрузка",
                        "CREATED_AT": "Создано на",
                        "SIZE": "Размер",
                        "STATUS": "Статус",
                        "DOWNLOAD": "Скачать",
                        "AVAILABLE": "имеется в наличии",
                        "DISCONNECTED": "отключен",
                        "DELETED": "удалено",
                        "EXPIRED": "истекший",
                        "WAITING": "ожидающий",
                        "FAILED": "не смогли",
                        "REFRESH": "Обновить",
                        "NO_ARCHIVE_MESSAGE": "Нет записи видеозвонка",
                        "NAME": "Имя",
                        "STORAGE": "Место хранения",
                        "DURATION": "Продолжительность",
                        "ARCHIVES": "Записи видеозвонков",
                        "PLAY": "Играть",
                        "DELETE": "Удалить",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "Скачать запись",
                            "GENERATING": "Создание URL-адреса для загрузки",
                            "GENERATED": "Сгенерированный URL-адрес загрузки",
                            "CANNOT_GENERATED": "Не удается сгенерировать URL-адрес загрузки.",
                            "DOWNLOAD": "Скачать",
                            "CLOSE": "Закрывать"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "Удалить запись",
                            "MESSAGE": "Запись видеозвонка будет удалена.",
                            "CAUTION": "ПРЕДУПРЕЖДЕНИЕ. Эта запись также будет удалена из вашего хранилища Azure.",
                            "CANCEL": "Отмена",
                            "DELETE": "Удалить"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "Конвертер",
                    "STP_ONLY": "Поддерживаются только форматы файлов .stp и .step.",
                    "ERROR_UPLOAD": "Произошла ошибка при загрузке файла.",
                    "DRAG": "Перетащите файл сюда",
                    "OR": "или",
                    "CHOOSE": "Выбрать файл",
                    "CONVERT": "Конвертировать",
                    "SUPPORTED": "Поддерживаемые форматы файлов:",
                    "BACK": "Назад",
                    "DOWNLOAD": "Скачать",
                    "ERROR_LOAD": "Произошла ошибка при загрузке объекта."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "Что нового",
                    "NO_UNREAD_UPDATE": "Нет непрочитанных обновлений"
                },
                "JOIN_MODAL": {
                    "JOIN" : "логин",
                    "CALL": "ВЫЗОВ",
                    "CANCEL": "отменить",
                    "MIRROR_VIDEO": "Зеркальное видео",
                    "PREFERRED_RESOLUTION": "Предпочтительное разрешение",
                    "RESOLUTION_NOTE": "Примечание. Если ваше устройство не поддерживает запрошенное вами разрешение, будет использоваться следующее по величине разрешение.",
                    "CAM_MIC_PERM_REQUIRED": "Требуется разрешение камеры и микрофона",
                    "CAM_MIC_PERM_DENIED": "Доступ к камере или микрофону запрещен",
                    "CAM_MIC_CANT_ACCESS": "Мы не можем получить доступ к вашей камере или микрофону",
                    "JOIN_CAM_OFF": "Присоединиться с выключенной камерой",
                    "JOIN_MIC_OFF": "Присоединиться с выключенным микрофоном",
                    "JOIN_CAM_MIC_OFF": "Присоединяйтесь с выключенной камерой и микрофоном",
                    "JOIN_NO_DEVICE": "Присоединяйтесь без камеры и микрофона",
                    "ALLOW_ACCESS": "Вам необходимо разрешить доступ к камере и микрофону в настройках браузера (после предоставления доступа вы все равно можете выключить камеру или микрофон).",
                    "TRY_AGAIN": "Повторите попытку/обновите страницу и выберите 'Разрешить' при появлении запроса в браузере."
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "Устройство не найдено",
                    "JOIN_BODY": "К этому устройству не подключены микрофон и камера. Другие пользователи не смогут слышать или видеть вас через это устройство. Вы все еще хотите присоединиться?",
                    "CALL_BODY": "К этому устройству не подключены микрофон и камера. Другие пользователи не смогут слышать или видеть вас через это устройство. Вы все еще хотите позвонить?",
                    "CANCEL": "отменить",
                    "JOIN": "Присоединяйтесь в любом случае",
                    "CALL": "Звоните в любом случае"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "Обработка и безопасность формы утверждения персональных данных",
                    "REJECTION_BUTTON": "Отклонить",
                    "AGREEMENT_BUTTON": "Согласен"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "Отменить договор?",
                    "ERROR": "Произошла ошибка.",
                    "STATEMENT": "Если вы не примете договор, вы не сможете войти в систему.",
                    "CANCEL_BUTTON": "отменить",
                    "PROCEED_BUTTON": "Продолжить"
                },
                "JOIN_UNKNOWN_ERROR" : "Произошла ошибка при входе в комнату.",
                "JOIN_CONCURRENT_ERROR" : "Вы достигли ограничения по числу одновременных пользователей в своей учетной записи. Пожалуйста, свяжитесь с вашим администратором для получения более подробной информации.",
                "JOIN_EXPERT_CONCURRENT_ERROR" : "Вы достигли ограничения по числу одновременных пользователей в своей учетной записи. Пожалуйста, свяжитесь с вашим администратором для получения более подробной информации.",
                "NO_TRAINING_LICENSE": "Возникла проблема с лицензией на вашу тренировочную комнату. Пожалуйста, свяжитесь с вашим администратором.",
                "TRAINING_LICENSE_EXPIRED": "Срок действия вашей лицензии на комнату для тренировок истек. Пожалуйста, свяжитесь с вашим администратором.",
                "ASK_TRAINING_HOST": "Произошла ошибка при входе в тренировочную комнату. Пожалуйста, свяжитесь с хозяином.",
                "JOIN_CALL_IN_PROGRESS": "В вашей личной переговорной поступил еще один звонок.",
                "NOT_SUPPORTED_TITLE": "Несовместимый браузер",
                "NOT_SUPPORTED_MESSAGE": "Ваш браузер не совместим. Пожалуйста, используйте Google Chrome, Mozilla Firefox, Safari или Microsoft Edge (версия 79 или новее).",
                "NO_IOS_MESSAGE": "Ваш браузер не совместим. Пожалуйста, используйте приложение {{ appName }} Remote или используйте Safari.",
                "IOS_VERSION_MESSAGE": "Ваш браузер не совместим. Пожалуйста, используйте приложение {{ appName }} Remote.",
                "NOT_SUPPORTED_CLOSE": "близко",
                "IDLE_MODAL_TITLE": "ошибка",
                "IDLE_MODAL_MESSAGE": "Вы не совершали никаких сделок в течение длительного времени.",
                "IDLE_MODAL_COUNT": "Вы выйдете из системы через {{count}} секунд.",
                "IDLE_MODAL_OK": "Я вернулся",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "Разрешить запись?",
                    "MESSAGE": "Встреча в этой комнате будет записана. Вам необходимо разрешить запись видео, чтобы присоединиться к этой комнате.",
                    "DENY": "Отрицать",
                    "ALLOW": "Позволять"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "ошибка",
                    "CLOSE": "Продолжить в любом случае",
                    "REJOIN": "присоединиться",
                    "ENDCALL": "Оставлять",
                    "ERRORS": {
                        "INTERNET": "Не удается подключиться к сеансу. Пожалуйста, проверьте ваше интернет-соединение.",
                        "TRY_AGAIN": "Произошла ошибка при подключении сеанса. Пожалуйста, попробуйте позже.",
                        "UNKNOWN": "Произошла ошибка при подключении сеанса.",
                        "PUBLISHER_FAILED": "Не удалось поделиться вашим видео потоком с другими участниками.",
                        "PUBLISHER_CAM_MIC_ACCESS": "Убедитесь, что ваша камера и микрофон работают, а разрешения для камеры/микрофона предоставлены.",
                        "SUBSCRIBER_FAILED": "Не удалось подключиться к одному из участников видеопотока."
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "чат",
                    "PARTICIPANTS_TITLE" : "участники",
                    "FILES_TITLE" : "Файлы",
                    "SETTINGS_TITLE" : "настройки",
                    "SHOW_TICKET": "Показать билет",
                    "ATTACH_TO_TICKET": "Прикрепить к тикету",
                    "ATTACH_SESSION_TO_TICKET": "Прикрепить сеанс к тикету",
                    "OPEN_WORKFLOW": "Открыть рабочий процесс",
                    "CHAT" : {
                        "SEE_TRANSLATION": "Посмотреть перевод",
                        "SEE_ORIGINAL": "См Оригинал",
                        "TRANSLATING": "Идет перевод",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "Перетащите файлы сюда",
                            "UPLOAD_TITLE": "Загрузить файлы",
                            "IMAGE": "Образ",
                            "PDF": "Pdf",
                            "3D_OBJECT": "3D объект",
                            "OTHER": "Другой",
                            "MULTIPLE_OBJECTS": "Мы нашли несколько объектов в ваших файлах. Пожалуйста, загружайте один объект (с текстурами, если существует) за раз.",
                            "LARGER_THAN": "Больше {{ megabytes }} мб",
                            "FILETYPE_PROHIBITED": "Тип файла запрещен",
                            "START_UPLOAD": "ЗАГРУЗИТЬ",
                            "CANCEL_UPLOAD": "СТОП",
                            "CLOSE_UPLOAD": "БЛИЗКО",
                            "CANCEL_MODAL_TITLE": "Остановить загрузку?",
                            "CANCEL_MODAL_MESSAGE": "Это остановит текущие загрузки.",
                            "CANCEL_MODAL_CLOSE": "отменить",
                            "CANCEL_MODAL_CANCEL": "Стоп"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "Удалить файл?",
                            "MESSAGE": "Файл будет удален.",
                            "CLOSE": "близко",
                            "DELETE": "удалять"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "Сведения о файле",
                            "FILENAME": "Имя файла",
                            "SIZE": "Размер",
                            "TYPE": "Тип",
                            "UPLOAD_TIME": "Время загрузки",
                            "DOWNLOAD": "Скачать",
                            "CLOSE": "близко",
                            "FILECOUNT": "Общее количество файлов"
                        },
                        "COLLABORATE": "сотрудничать",
                        "CLOSE_COLLABORATION": "Закрыть Сотрудничество",
                        "DOWNLOAD": "Скачать",
                        "DELETE": "удалять",
                        "DETAILS": "подробности",
                        "SEND_TO_FILES": "Отправить в файлы",
                        "FILE_DELETED": "Файл удален",
                        "JOIN_ROOM" : "{{owner_info}} присоединился к комнате.",
                        "LEAVE_ROOM" : "{{owner_info}} покинул комнату.",
                        "REACTION": "{{ owner_info }} послал реакцию.",
                        "REQUEST_SCREENSHOT": "{{owner_info}} запрошенный снимок.",
                        "SHARE_SCREENSHOT" : "{{owner_info}} поделился снимком.",
                        "SAVED_COLLABORATION": "Совместная работа сохранена.",
                        "SHARE_IMAGE" : "{{owner_info}} поделился изображением.",
                        "SHARE_PDF" : "{{owner_info}} поделился pdf.",
                        "SHARE_OTHER" : "{{owner_info}} поделился файлом.",
                        "SHARE_OBJECT" : "{{owner_info}} поделился 3D-объектом.",
                        "COLLABORATED" : "{{owner_info}} начал сотрудничество.",
                        "TYPE_HERE" : "введите здесь ...",
                        "PLEASE_WAIT_OTHERS": "Пожалуйста, подождите, пока другие пользователи присоединятся.",
                        "DOWNLOAD_STARTED_SOON": "Загрузка начнется в ближайшее время.",
                        "DOWNLOAD_FAILED": "Ошибка загрузки.",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Загрузка объекта пока не поддерживается.",
                        "DOWNLOAD_NOT_SUPPORTED": "Загрузка еще не поддерживается.",
                        "CLOSE_PREV_COLLABORATION_TITLE": "Закрыть текущее файловое сотрудничество?",
                        "CLOSE_COLLABORATION_TITLE": "Тесное файловое сотрудничество?",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "This will close the current file-collaboration and start a new one.",
                        "CLOSE_COLLABORATION_MESSAGE": "Это закроет совместную работу с файлами.",
                        "CLOSE_PREV_COLLABORATION_YES": "проследовать",
                        "CLOSE_PREV_COLLABORATION_NO": "отменить",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Открытое файловое сотрудничество?",
                            "MESSAGE_AUTHORIZED": "Закрепленное окно существует. Вы хотите открепить его и открыть файл-коллаборацию?",
                            "MESSAGE_UNAUTHORIZED": "Файл-совместная работа не может быть открыта, потому что существует закрепленное окно.",
                            "CANCEL": "Отмена",
                            "CLOSE": "близко",
                            "PROCEED": "проследовать"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "Закрыть AR+?",
                            "MESSAGE": "Вам нужно закрыть AR+, прежде чем вы сможете открыть сотрудничество. Вы уверены, что хотите закрыть AR+?",
                            "NO": "нет",
                            "YES": "да"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "(хозяин)",
                        "LOWER_ALL_HANDS": "Опустить все руки",
                        "RAISED_HAND": "{{ name }} поднял руку.",
                        "DENIED_PUBLISH": "{{ name }} отказался присоединиться к видео/аудио общению.",
                        "PARTICIPANT_LIMIT_REACHED": "Достигнут лимит участников видео/аудио связи.",
                        "CALLING": "Вызов: {{ participants }}"
                    },
                    "FILES": {
                        "INFO_TEXT": "Все эксперты и соадминистраторы, имеющие доступ к этой комнате, могут просматривать и изменять файлы в этом разделе.",
                        "DOWNLOAD": "Скачать",
                        "SEND_TO_SESSION": "Отправить на сеанс",
                        "DELETE": "Удалить",
                        "UPLOAD_FILE": "Загрузить файл",
                        "FILE_CONTENTS": "Содержимое файла:",
                        "FILE_NAME": "Имя файла:",
                        "FILE_SIZE": "Размер файла:",
                        "TOTAL_SIZE": "Общий размер:",
                        "DOWNLOAD_STARTED_SOON": "Загрузка начнется в ближайшее время.",
                        "DOWNLOAD_FAILED": "Ошибка загрузки.",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "Удалить файл?",
                            "MESSAGE_DELETE": "Вы уверены, что хотите удалить этот файл?",
                            "CANCEL": "Отмена",
                            "DELETE": "Удалить"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "Микрофон",
                        "CAMERA": "камера",
                        "TRANSLATE_OTHERS_MSG_TO": "Перевести другие сообщения в:",
                        "TRANSLATE_MY_MSG_TO": "Перевести мои сообщения в:",
                        "CREATE_GUEST_ACCESS": "Создать гостевой доступ",
                        "GENERATING": "порождающий",
                        "GUEST_ACCESS": "Гостевой доступ",
                        "COPY_LINK": "копия",
                        "LINK_COPIED": "Ссылка скопирована в буфер обмена.",
                        "LINK_GENERATED": "Ссылка для присоединения к сеансу создана.",
                        "CANNOT_CREATE_GUEST_ACCESS": "Невозможно создать гостевой доступ.",
                        "NO_LINK_PERMISSION": "У вас нет разрешения на создание ссылки для гостевого доступа. Пожалуйста, свяжитесь со своим администратором.",
                        "SHARE": "доля",
                        "SHARE_LINK_VIA_SMS": "Поделиться ссылкой через SMS",
                        "SMS_SEND": "Ссылка отправлена ​​по SMS",
                        "OPENING": "Открытие",
                        "SEND": "Отправить",
                        "SMS_LIMIT_REACHED": "Достигнут лимит отправленных SMS. Пожалуйста, свяжитесь со своим администратором.",
                        "ERROR_OCCURED": "Произошла ошибка.",
                        "SMS_LICENSE_PERMISSION": "У вас нет разрешения на отправку SMS. Пожалуйста, свяжитесь со своим администратором.",
                        "RESHARE": "Вы можете делиться ссылкой раз в минуту.",
                        "DIDNT_GET": "Не получили ссылку?",
                        "PHONE_NUMBERS": "Недавно использованные номера телефонов",
                        "RESEND": "Отправить",
                        "CANCEL": "Отмена",
                        "CONNECT_VIA_FIELD_CODE": "Соединитесь с пользователем через Field ID",
                        "CONNECT": "Соединять",
                        "INVITATION_SENT": "Приглашение отправлено пользователю.",
                        "INVITATION_COULD_NOT_SENT": "Приглашение не может быть отправлено пользователю.",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "Битрейт аудио",
                    "AUDIO_PACKET_LOSS": "Потеря аудиопакета",
                    "VIDEO_BITRATE": "Битрейт видео",
                    "VIDEO_PACKET_LOSS": "Потеря видеопакета",
                    "RESOLUTION": "разрешение",
                    "WAIT_OTHER_USERS" : "Пожалуйста, подождите, пока другие пользователи присоединятся.",
                    "WAIT_EXPERT": "Пожалуйста, подождите, пока эксперт присоединится.",
                    "WAIT_MASTER": "Пожалуйста, подождите, пока хозяин начнет сеанс.",
                    "START_SESSION": "НАЧАЛО СЕССИИ",
                    "HOST_WITHDRAW_REQUEST": "хозяин отозвать видео/аудио запрос.",
                    "NO_CAM_MIC": "Ваша камера и микрофон недоступны.",
                    "NO_CAM": "Ваша камера недоступна.",
                    "NO_MIC": "Ваш микрофон недоступен.",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "Присоединиться к видео/аудио связи?",
                        "MESSAGE": "хозяин хотел бы, чтобы вы включили ваше видео / аудио.",
                        "DENY": "Отрицать",
                        "ACCEPT": "принимать"
                    },
                    "PUBLISHER" : {
                        "YOU": "Вы",
                        "SCREEN_SHARE_MESSAGE": "Вы делитесь своим экраном",
                        "STOP_SCREEN_SHARING": "Прекратить совместное использование"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "O status da rede não pode ser exibido porque o aplicativo deste participante não está atualizado.",
                        "SNAPSHOT": "снимок",
                        "AR_PLUS": "AR Сотрудничество",
                        "SCREENSHOT_REQUESTED": "Снимок запрошен",
                        "VIDEO_NOT_AVAILABLE": "Видео не доступно",
                        "WEAK_SIGNAL": "Слабый сигнал",
                        "AUDIO_ONLY_MODE": "Только аудио режим",
                        "FLASH": "вспышка",
                        "AR_NOT_AVAILABLE": "AR не доступен для этого устройства.",
                        "CHARGING": "Зарядка",
                        "LOW_BATTERY": "Низкий заряд батареи",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "Закрыть AR+?",
                            "MESSAGE": "Вы уверены, что хотите закрыть AR+?",
                            "NO": "нет",
                            "YES": "да"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "Открыть AR+?",
                            "MESSAGE_AUTHORIZED": "Прикрепленное окно существует. Вы хотите открепить его и открыть AR+?",
                            "MESSAGE_UNAUTHORIZED": "AR+ не может быть открыт, потому что закрепленное окно существует.",
                            "CANCEL": "Отмена",
                            "CLOSE": "близко",
                            "PROCEED": "проследовать"
                        },
                        "REFRESH_SURFACES": "Обновить поверхности",
                        "AR_PLUS_LOCKED": "AR+ заблокирован. Сначала разблокируйте AR+."
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "Поделиться экраном",
                        "STOP_SHARE": "Прекратить совместное использование",
                        "MIC_OFF": "микрофон",
                        "CAM_OFF": "камера",
                        "CAM_MIC_CANT_ACCESS": "Мы не можем получить доступ к вашей камере или микрофону",
                        "LEAVE_CALL": "Оставлять",
                        "LEAVE_SESSION": "Выйти из сеанса",
                        "LEAVE_MEETING": "Покинуть встречу",
                        "END_SESSION_FOR_ALL": "Завершить сеанс для всех",
                        "END_MEETING_FOR_ALL": "Завершить встречу для всех",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "Выйти из сеанса?",
                            "TITLE_LEAVE_MEETING": "Покинуть встречу?",
                            "TITLE_END_ALL": "Завершить сеанс для всех?",
                            "TITLE_END_ALL_MEETING": "Завершить встречу для всех?",
                            "MESSAGE_LEAVE": "Вы уверены, что хотите покинуть сеанс?",
                            "MESSAGE_END_ALL": "Вы уверены, что хотите завершить сеанс?",
                            "MESSAGE_LEAVE_MEETING": "Вы уверены, что хотите покинуть собрание?",
                            "MESSAGE_END_ALL_MEETING": "Вы уверены, что хотите завершить встречу?",
                            "CANCEL": "отменить",
                            "END": "Конец",
                            "LEAVE": "Покинуть",
                            "REMOVE_MEETING_LINK": "Также отключите и удалите ссылку на встречу"
                        },
                        "RAISE_HAND": "Поднять руку",
                        "LOWER_HAND": "Нижняя рука",
                        "RECORD": "запись",
                        "AUTO_RECORD": "Авто запись",
                        "STOP_RECORD": "Остановить запись",
                        "CANCEL": "Отменить запрос",
                        "ASK_ARCHIVE_PERMISSION": "Спросите разрешение на запись",
                        "REACTION": "реакция",
                        "EXTENSION_MODAL_TITLE": "Требуется расширение",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome требует расширения для функции общего доступа к экрану. Пожалуйста, установите расширение или используйте Mozilla Firefox.",
                        "EXTENSION_MODAL_NO": "отменить",
                        "EXTENSION_MODAL_YES": "Открыть страницу расширения",
                        "ARCHIVE_NO_PERMISSION": "У вас нет разрешения на запись этого сеанса. Пожалуйста, свяжитесь с вашим администратором.",
                        "P2P_NO_ARCHIVE": "Запись недоступна для одноранговых видеозвонков. Пожалуйста, свяжитесь с вашим администратором.",
                        "SCREEN_SHARE_UPDATE": "Ваша текущая версия браузера не поддерживает демонстрацию экрана. Пожалуйста, обновите ваш браузер.",
                        "SCREEN_SHARE_NOT_SUPPORTED": "Ваш браузер не поддерживает совместное использование экрана.",
                        "SCREEN_SHARE_USE_OTHER": "Ваш браузер не поддерживает совместное использование экрана. Пожалуйста, используйте Google Chrome или Mozilla Firefox.",
                        "SCREEN_SHARE_FAILED": "Невозможно поделиться экраном.",
                        "ARCHIVE_REQUESTED": "Запись видео начнется. Требуется ваше разрешение.",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} хочет начать видеозапись. Требуется ваше разрешение.",
                        "DENY": "Отрицать",
                        "ALLOW": "Позволять"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "Предыдущая страница",
                        "NEXT_PAGE": "следущая страница"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "Некоторые пользователи не могут загрузить совместную работу с файлами.",
                        "DOWNLOAD_FAILED": "Невозможно скачать совместный файл.",
                        "END_COLL_TITLE": "Тесное файловое сотрудничество?",
                        "END_COLL_MESSAGE": "Это закроет файловое сотрудничество.",
                        "END_COLL_NO": "отменить",
                        "END_COLL_YES": "проследовать",
                        "ALREADY_ENDED": "Совместная работа с файлами уже завершена.",
                        "CANNOT_END_COLLABORATION": "Невозможно завершить совместную работу с файлами.",
                        "ANNOTATE": "Пометки",
                        "FULLSCREEN": "Полноэкранный",
                        "DOWNLOAD_COLLABORATION": "Скачать Сотрудничество",
                        "SNAPSHOT_COLLABORATION": "снимок",
                        "UNDO": "Отменить",
                        "REDO": "Повторить",
                        "REVERT": "Чисто",
                        "RELOAD": "Перезагрузить"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "Окно булавки?",
                        "MESSAGE": "Пин в режиме AR+ невозможен. Закрыть AR+ и закрепить?",
                        "CANCEL": "Отмена",
                        "PROCEED": "проследовать"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "Похоже, что-то пошло не так. Мы пытаемся восстановить ваш звонок."
            },
            "SESSION_RATING": {
                "BAD": "Плохой",
                "POOR": "Неадекватный",
                "FAIR": "в среднем",
                "GOOD": "Хороший",
                "EXCELLENT": "Превосходно",
                "RATING_MESSAGE" : "Как было качество сеанса?",
                "REVIEW_MESSAGE" : "Расскажите, почему (необязательно)",
                "SUCCESS_MESSAGE": "Спасибо за оценку сеанса.",
                "CLOSE": "Закрывать",
                "SUBMIT": "Ответить",
                "DISMISS": "Отклонять"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "Вернуться к лобби",
                "RUN_PRECALL_TEST": "Выполнить тест Precall",
                "WHAT_TEST": {
                    "TITLE": "Мы собираемся проверить",
                    "CONNECTIVITY": "Подключение ко всем медиа-серверам.",
                    "STATS": "Собрать битрейт и статистику потери пакетов.",
                    "SETUP": "Настройка аппаратного и программного обеспечения на конечной точке (камера, микрофон, браузер)."
                },
                "BEFORE_START": {
                    "TITLE": "Прежде чем ты начнешь",
                    "MAKE_SURE": "Удостовериться;",
                    "RIGHT_NETWORK": "Вы находитесь в конкретной сети, которую вы собираетесь тестировать.",
                    "TCP_PORT_OPEN": "У вас открыт хотя бы TCP-порт 443.",
                    "RIGHT_HARDWARE": "Правильная камера и микрофон выбраны.",
                    "BANDWITH": "Пропускная способность составляет более 350 Кбит / с загрузки и скачивания."
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "Настройка аппаратного/программного обеспечения",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "Операционная система",
                        "BETTER_ALTERNATIVE_IOS": "Вы можете загрузить приложение {{ appName }} Remote из магазина AppStore для более удобной работы.",
                        "BETTER_ALTERNATIVE_ANDROID": "Вы можете загрузить приложение {{ appName }} Remote из магазина Google Play для более удобной работы."
                    },
                    "BROWSER": {
                        "MESSAGE": "браузер",
                        "NOT_SUPPORTED": "Ваш браузер не поддерживается. Пожалуйста, используйте Google Chrome, Mozilla Firefox, Safari или Microsoft Edge (версия 79 или новее).",
                        "NOT_COMPATIBLE": "Ваш браузер не совместим. Пожалуйста, обновите ваш браузер.",
                        "USE_SAFARI": "Ваш браузер не совместим. Пожалуйста, используйте приложение {{ appName }} Remote или используйте Safari."
                    },
                    "HARDWARE": {
                        "MESSAGE": "Доступ к камере/микрофону",
                        "CANT_ACCESS": "Мы не можем получить доступ к вашей камере/микрофону."
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "Подключение к нашим серверам",
                    "INTERNET": {
                        "MESSAGE": "интернет-соединение",
                        "OFFLINE": "Ваше интернет-соединение, кажется, в автономном режиме."
                    },
                    "SERVERS": {
                        "MESSAGE": "Подключение к нашим серверам",
                        "UNKNOWN_ERROR_TRY": "Произошла ошибка при подключении к серверам. Пожалуйста, попробуйте позже.",
                        "UNKNOWN_ERROR": "Произошла ошибка при подключении к серверам."
                    }
                },
                "QUALITY": {
                    "TITLE": "Качество аудио/видео",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "Качество аудио/видео",
                        "UNKNOWN_ERROR": "Произошла ошибка при тестировании качества аудио / видео.",
                        "VIDEO": "видео",
                        "VIDEO_QUALITY": "Качество видео: ",
                        "VIDEO_PACKET_LOSS": "Потеря пакета: ",
                        "VIDEO_BITRATE": "Видео битрейт: ",
                        "AUDIO": "аудио",
                        "AUDIO_QUALITY": "Качество звука",
                        "AUDIO_PACKET_LOSS": "Потеря пакета: ",
                        "AUDIO_BITRATE": "Качество звука: ",
                        "QUALITY_EXCELLENT": "(Отлично)",
                        "QUALITY_GOOD": "(Хорошо)",
                        "QUALITY_BAD": "(Плохо)"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "Стоп Тест?",
                    "MESSAGE": "Это остановит тест Precall.",
                    "NO": "Отмена",
                    "YES": "Стоп"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "Добавить новое",
                "SECONDARY_PLACEHOLDER": "Введите адрес электронной почты",
                "INVALID_EMAIL": "Неверный формат электронной почты."
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "Интеграция уже используется",
                    "MISSING_PARAMETERS": "Не хватает параметров",
                    "CALL_IN_PROGRESS": "Звонок в процессе",
                    "USER_IN_ANOTHER_ROOM": "Пользователь в другой комнате"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} Центр помощи",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote Центр помощи",
            "FAILED": "Произошла ошибка."
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{appName}} Удаленный гостевой доступ",
                "SESSION_NOT_FOUND": "Запрошенный вами сеанс не найден.",
                "SESSION_NOT_AVAILABLE": "Эта сессия больше не доступна.",
                "CONCURRENT_LIMIT_REACHED": "Достигнуто одновременное ограничение пользователя. Пожалуйста, свяжитесь с вашим администратором.",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "Достигнуто одновременное ограничение пользователя. Пожалуйста, свяжитесь с вашим администратором.",
                "UNKNOWN_ERROR": "Что-то пошло не так.",
                "ABOUT_TO_JOIN": "Вы собираетесь присоединиться к ",
                "ENTER_NAME": "Введите ваше имя",
                "NAME_REQUIRED": "Имя обязательно",
                "NAME_SHORT": "Имя должно содержать не менее 2 символов",
                "JOIN": "логин",
                "CONTINUE_TO_WEBSITE": "Продолжить через браузер"
            },
            "ARCHIVE_LIST": {
                "TITLE": "Записи видеозвонков",
                "LOADING": "Загрузка",
                "LOAD_FAILED": "Произошла ошибка.",
                "CREATED_AT": "Создано на",
                "SIZE": "Размер",
                "STATUS": "Статус",
                "DOWNLOAD": "Скачать",
                "GENERATING": "Создание ссылки",
                "CLICK_TO_DOWNLOAD": "Нажмите, чтобы скачать",
                "AVAILABLE": "имеется в наличии",
                "DISCONNECTED": "отключен",
                "DELETED": "удалено",
                "EXPIRED": "истекший",
                "WAITING": "ожидающий",
                "FAILED": "не смогли"
            },
            "AUTHENTICATE": {
                "MESSAGE": "Произошла ошибка."
            },
            "AD_LOGIN": {
                "MESSAGE": "Произошла ошибка."
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "Ваша учетная запись не подключена к Azure AD.",
                "PERMISSION_DENIED": "У вас нет разрешения на просмотр этой страницы.",
                "INTERNAL_ERROR": "Произошла ошибка.",
                "CONTACT_MAIL": "Пожалуйста, свяжитесь с <strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "Показать руководство по использованию",
            "NEXT": "следующий",
            "END": "Конец",
            "MIC_CAMERA": "Открыть/закрыть микрофон или камеру",
            "END_CALL": "Выйти из сеанса",
            "RECORD": "Начать/остановить запись для всего сеанса",
            "SCREEN_SHARING": "Запустите/остановите совместное использование экрана, чтобы показать, что вы делаете другим пользователям",
            "REACTION": "Отправить реакцию всем, полезно, когда голосового общения недостаточно",
            "OPEN_AR_PLUS": "открыто AR+",
            "DRAW_ON_SURFACE": "Нарисуйте на поверхностях, которые выделены синей сеткой в ​​прямом эфире с AR+",
            "OPEN_AR": "открыто AR",
            "HOLD_TO_HIGHLIGHT": "Нажмите и удерживайте в любом месте, чтобы выделить конкретную область в прямом эфире с AR",
            "TAKE_SNAPSHOT": "Сделайте качественный снимок от другого пользователя",
            "NO_CAMERA": "Камера другого участника должна быть включена",
            "WAIT_OR_SKIP": "Подождите другого пользователя или пропустите эту функцию",
            "COLLABORATE": "Совместная работа над снимком: эскиз, нанесенные диаграммы, специальные формы, тексты",
            "OPEN_ANNOTATION": "Открытая аннотация",
            "SKETCH_ON_COLL": "Эскиз на панели совместной работы",
            "END_TUTORIAL": "Вы можете получить доступ к этому учебнику в любое время здесь",
            "USER_TUTORIAL": "Руководство пользователя",
            "GUIDE": "Это руководство пользователя шаг за шагом проведет вас через платформу.",
            "DONT_SHOW": "Больше не показывать",
            "SKIP_TUTORIAL": "Пропустить учебник",
            "CANCEL": "Отмена",
            "SKIP": "Пропускать",
            "ASK_AGAIN": "Вы уверены, что хотите пропустить это руководство?"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "К сожалению, запрошенная вами страница не найдена.",
            "NO_LONGER_AVAILABLE": "URL может быть написан с ошибкой или страница, которую вы ищете, больше не доступна."
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "Файл не найден",
            "IF_DOWNLOAD_NOT_STARTED": "Если загрузка не началась, ",
            "CLICK_HERE": "нажмите здесь"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Элементов на странице:",
        "NEXT_PAGE": "Следующая страница",
        "PREVIOUS_PAGE": "Предыдущая страница",
        "FIRST_PAGE": "Первая страница",
        "LAST_PAGE": "Последняя страница",
        "RANGE": "{{start}} – {{end}} из {{length}}",
        "RANGE_ZERO": "0 из {{length}}"
    }
}